import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
// import PaginationOld from '../pages/PaginationOld';
import { db } from '../../firebase'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";
import ScrollToTop from "react-scroll-to-top";





function MenJeans() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(78);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [saree, setSaree] = useState([])
    const navigate = useNavigate()

    const sareeCollectionRef = collection(db, "MenJeans");
    useEffect(() => {

        const getSaree = async () => {
            const data = await getDocs(sareeCollectionRef);
            setSaree(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getSaree()
    }, [])
    return (

        <>
            <Navbar />

            <br />
            <ScrollToTop smooth top="100" color="maroon"/>

            <br />
            <br />
            <br />


            <br />
            <div className='sareepage'>
                <div className='album py-1'>
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link style={{ color: "black" }} to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/mens-wear" style={{ color: "black" }} >Back</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Men Jeans <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
            <div className="album py-1">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" className="form-control" placeholder="Search" name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div className="album py-1">

                <div className="container">

                    <div className="row">
                        {saree.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                val.des.toLowerCase().includes(searchTerm.toLowerCase())



                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((siddheswaribastralaya) => {
                            return (
                                <div className="col-md-4 mt-3">
                                    <div className="card mb-4">
                                        <img className="card-img-top" src={siddheswaribastralaya.img} alt={siddheswaribastralaya.title}/>
                                        <div className="card-body">

                                            <h6 className="card-text"> <b>{siddheswaribastralaya.title}</b></h6>
                                            {/* < h5 style={{ color: "Darkblue" }} className="card-text"> ₹{siddheswaribastralaya.price} </h5> */}

                                            <p style={{color: "grey"}} className="card-text mb-2">{siddheswaribastralaya.des}</p>

                                            <div className="d-flex justify-content-between align-items-center">

                                                <a href='tel: 9339704703' className="callbook mb-0">Call Book</a>
                                                <ReactWhatsapp number="+91 9832223839" className="whatsapp mb-0" message="I want to buy this saree, contact me"> Whatsapp Inquiry</ReactWhatsapp>

                                            </div>



                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>


                </div>
            </div>

        </>

    );
}

export default MenJeans;



